<template>
  <v-app-bar app flat color="secondary" dark class="elevation-12">
    <template>
      <v-tabs
        slider-color="none"
        slider-size="0"
        show-arrows
        icons-and-text
        next-icon="mdi-arrow-right-bold-box-outline"
        prev-icon="mdi-arrow-left-bold-box-outline"
      >
        <v-spacer />
        <a href="https://payx.rs">
          <v-tab>
            <img class="pt-2" height="60px" src="@/assets/payx_logo.png" />
          </v-tab>
        </a>
        <v-spacer />
      </v-tabs>
    </template>
  </v-app-bar>
</template>

<script>
export default {};
</script>

<style scoped></style>
